import { EventCategory } from '@fluidx/office-fluid-types';
class ConsoleLogProcessor {
    logEvent(event) {
        switch (event.category) {
            case EventCategory.Error:
                console.error('%cPurple: %c%s', 'color: purple; font-style: italic', '', JSON.stringify(event));
                break;
            default:
                console.log('%cPurple: %c%s', 'color: purple; font-style: italic', '', JSON.stringify(event));
        }
    }
    setUserContext(_context) { }
    shutdown() { }
    loadFull() {
        return Promise.resolve();
    }
    loadAsha() { }
}
export const consoleLogProcessor = new ConsoleLogProcessor();
//# sourceMappingURL=ConsoleLogProcessor.js.map